export default __webpack_public_path__ + "static/media/noResultsEmails.535b8e8d.svg";